/* eslint-disable no-restricted-globals */
import { CryptoRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$window', '$http', '$rootScope', 'Util', '$translate'];

class CoinbaseAccount {

    constructor($scope, $window, $http, $rootScope, Util, $translate) {

        $scope.isLoggedInCoinbase = false;
        $scope.dataIsLoading = true;
        $scope.activeCrypto = 'ETH';
        $scope.activeCurrency = $rootScope.cryptoCurrency || 'USD';
        $scope.amountValue = 0;
        $scope.transactionConsent = false;
        $scope.transactionConsentError = false;
        $scope.enableReviewWithdraw = false;
        $scope.hasErrorsReviewWithdraw = true;
        $scope.hasErrorsWithdraw = true;
        $scope.withdrawFromWallet = {};
        $scope.withdrawFromWallet.selected = '';
        $scope.withdrawToWallet = {};
        $scope.withdrawToWallet.selected = '';
        $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_1');

        $scope.withdrawStep = '1';

        $scope.back = () => {

            $scope.withdrawStep = '1';

        };

        $scope.getWithdrawQuote = () => {

            $scope.quote = { networkFee: '', transfer: '', networkFeeNumber: 0 };
            const fee = +($scope.fees.txFeeMap[$scope.activeCrypto]);
            const feeInCurrency = fee * $scope.prices.conversionRateMap[$scope.activeCurrency];
            $scope.quote.networkFee =
                `${+Util.toFixed(fee, 6)} ${$scope.activeCrypto} (${Util.toFixed(feeInCurrency, 2)} ${$scope.activeCurrency})`;

            $scope.quote.networkFeeNumber = Util.toFixed(fee, 6);

            if (!$scope.amountError && $scope.amountValue > 0) {

                const transferCrypto = $scope.amountValue - fee;
                const transferInCurency =
                    transferCrypto * $scope.prices.conversionRateMap[$scope.activeCurrency];
                $scope.quote.transfer = `${Util.toFixed(transferCrypto, 6)} ${$scope.activeCrypto} (${Util.toFixed(transferInCurency, 2)} ${$scope.activeCurrency})`;

                if ($scope.quote.transfer.indexOf('-') > -1) {

                    $scope.amountError = true;
                    $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_2');
                    $scope.quote.transfer = `0 ${$scope.activeCrypto} (0 ${$scope.activeCurrency})`;

                } else {

                    $scope.hasErrorsReviewWithdraw = false;

                }

            } else {

                $scope.quote.transfer = `0 ${$scope.activeCrypto} (0 ${$scope.activeCurrency})`;

                if ($scope.quote.transfer.indexOf('0') > -1) {

                    $scope.amountError = true;

                } else {

                    $scope.hasErrorsReviewWithdraw = false;

                }

            }

        };

        $scope.onChangeCheckbox = () => {

            $scope.transactionConsent = !$scope.transactionConsent;

            if ($scope.transactionConsent) {

                $scope.transactionConsentError = false;
                $scope.hasErrorsWithdraw = false;

            } else {

                $scope.transactionConsentError = true;
                $scope.hasErrorsWithdraw = true;

            }

        };

        $scope.validateReviewWithdraw = () => {

            if (($scope.amountError || typeof $scope.amountError === 'undefined') ||
                ($scope.WithdrawFromError || typeof $scope.WithdrawFromError === 'undefined') ||
                ($scope.WithdrawToError || typeof $scope.WithdrawToError === 'undefined')) {

                $scope.hasErrorsReviewWithdraw = true;

            } else {

                $scope.hasErrorsReviewWithdraw = false;

            }

        };

        $scope.maxAmoutValue = () => {

            angular.element('#amount').val($scope.totalBalance);
            $scope.amountValue = $scope.totalBalance;
            $scope.amountError = false;
            $scope.getWithdrawQuote();
            $scope.validateReviewWithdraw();

        };

        const onCryptoDataNext = () => {

            $scope.wallets = CryptoRepository.getAll('wallets') || {};
            $scope.fees = CryptoRepository.getAll('fees') || {};
            $scope.prices = CryptoRepository.getAll('prices') || {};

            if (Object.keys($scope.wallets).length >= 1) {

                $scope.balance =
                    Util.toFixed($scope.wallets[$scope.activeCrypto].balance, 6);

                $scope.totalBalance = $scope.wallets[$scope.activeCrypto].balance;
                $scope.amountValue = $scope.totalBalance;
                $scope.walletCurrencies = Object.keys($scope.wallets);
                $scope.withdrawFromWallet.selected = [$scope.walletCurrencies];
                $scope.amountError = false;
                $scope.WithdrawToError = false;

            }

            if (Object.keys($scope.fees).length >= 1 && Object.keys($scope.prices).length >= 1) {

                $scope.getWithdrawQuote();

            }

        };

        this.cryptoRepository = CryptoRepository.getObservable();
        this.cryptoSubscriber = this.cryptoRepository
            .subscribe(
                data => onCryptoDataNext(data),
                () => { },
                () => { },
            );

        $scope.validateAmount = ($event) => {

            $event.currentTarget.value =
            $event.currentTarget.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');

            if (isNaN(parseFloat($event.currentTarget.value)) ||
                parseFloat($event.currentTarget.value) > $scope.totalBalance) {

                $scope.amountError = true;
                if (isNaN(parseFloat($event.currentTarget.value))) {

                    $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_1');


                } else if (parseFloat($event.currentTarget.value) > $scope.totalBalance) {

                    $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_3');

                }

            } else {

                $scope.amountError = false;
                $scope.amountValue = $event.currentTarget.value;
                $scope.getWithdrawQuote();

            }

            $scope.validateReviewWithdraw();

        };

        $scope.validateWithdrawFrom = (activeWallet) => {

            if (activeWallet) {

                $scope.WithdrawFrom = $scope.wallets[activeWallet];
                $scope.WithdrawFromError = false;
                $scope.withdrawFromWallet.selected = activeWallet;

            }

            $scope.validateReviewWithdraw();

        };

        $scope.validateWithdrawTo = (activeWallet) => {

            if (activeWallet) {

                $scope.WithdrawTo = activeWallet;
                $scope.WithdrawToError = false;
                $scope.withdrawToWallet.selected = activeWallet;

            }

            $scope.validateReviewWithdraw();

        };

        $scope.reviewWithdraw = () => {

            Mixpanel.send('ConnectWeb Modal Button Click', {
                Modal: 'Crypto Withdraw Details',
                'Button Label': 'Review Withdraw',
                Destination: 'Coinbase',
                Coin: 'ETH',
                Amount: $scope.amountValue,
                'Network Fee': $scope.quote.networkFeeNumber,
            });

            if (!$scope.hasErrorsReviewWithdraw) {

                $scope.withdrawStep = '2';

                Mixpanel.send('ConnectWeb Modal Open', {
                    Modal: ' Crypto Withdraw Review',
                    Destination: 'Coinbase',
                    Coin: 'ETH',
                    Amount: $scope.amountValue,
                    'Network Fee': $scope.quote.networkFeeNumber,
                });

            }

        };

        $scope.proceedToCoinbase = () => {

            const width = 800; const height = 800;
            const left = ($window.innerWidth / 2) - (width / 2);
            const top = ($window.innerHeight / 2) - (height / 2);
            const strWindowFeatures = `toolbar=no, menubar=no, width=${width}, height=${height}, top=${top}, left=${left}`;
            const { clientId } = CWCONFIG.coinbase;
            const { redirectURI } = CWCONFIG.coinbase;
            $window.open(`https://www.coinbase.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectURI}&response_type=code&scope=wallet:accounts:read,wallet:addresses:read,wallet:addresses:create&account_currency=ETH`, 'coinbaseAuth', strWindowFeatures);
            $scope.waitingForCoinbase = true;

            Mixpanel.send('ConnectWeb Modal Button Click', {
                Modal: 'Crypto Withdraw Options',
                'Button Label': 'Link Coinbase Account',
            });

            Mixpanel.send('ConnectWeb Modal Open', {
                Modal: 'Crypto Coinbase Instructions',
            });

        };

        $scope.checkCoibaseAuth = () => {

            $scope.getCookie = (cname) => {

                const name = `${cname}=`;
                const decodedCookie = decodeURIComponent(document.cookie);
                const ca = decodedCookie.split(';');
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < ca.length; i++) {

                    let c = ca[i];
                    while (c.charAt(0) === ' ') {

                        c = c.substring(1);

                    }

                    if (c.indexOf(name) === 0) {

                        return c.substring(name.length, c.length);

                    }

                }

                return '';

            };

            const coinbaseCookie = $scope.getCookie('coinbase_token')
                .replace(/\\"/g, '"')
                .replace(/"{/g, '{')
                // eslint-disable-next-line no-useless-escape
                .replace(/}\"/g, '}')
                .replace(/\\054/g, ',');

            if (coinbaseCookie) {

                const parsedCookie = JSON.parse(coinbaseCookie);
                const coinbaseAccessToken = parsedCookie.access_token;

                $http({
                    method: 'GET',
                    url: 'https://api.coinbase.com/v2/user',
                    headers: {
                        Authorization: `Bearer ${coinbaseAccessToken}`,
                    },

                }).then((response) => {

                    $scope.coinbaseUserData = response.data;
                    $scope.userName = Util.deepFind($scope.coinbaseUserData, 'data.name');
                    $scope.isLoggedInCoinbase = true;
                    $scope.dataIsLoading = false;

                    Mixpanel.send('ConnectWeb Modal Open', {
                        Modal: 'Crypto Withdraw Details',
                    });

                }).catch(() => {

                    $scope.isLoggedInCoinbase = false;
                    $scope.dataIsLoading = false;

                    Mixpanel.send('ConnectWeb Modal Open', {
                        Modal: 'Crypto Withdraw Options',
                    });

                });

                $http({
                    method: 'GET',
                    url: 'https://api.coinbase.com/v2/accounts?scope=wallet:accounts:read',
                    headers: {
                        Authorization: `Bearer ${coinbaseAccessToken}`,
                    },

                }).then((response) => {

                    $scope.coinbaseAccounts = [];
                    const ethAccount = response.data.data.find(account => account.currency.code === 'ETH');
                    $scope.withdrawToWallet.selected = ethAccount;
                    $scope.WithdrawFromError = false;

                    if (ethAccount) {

                        $scope.coinbaseAccounts.push(ethAccount);
                        $scope.getAddresses();

                    } else {

                        $http({
                            method: 'GET',
                            url: 'https://api.coinbase.com/v2/accounts/ETH?scope=wallet:accounts:create',
                            headers: {
                                Authorization: `Bearer ${coinbaseAccessToken}`,
                            },

                        }).then((response2) => {

                            $scope.coinbaseAccounts.push(response2.data.data);
                            $scope.withdrawToWallet.selected = response2.data.data;
                            $scope.getAddresses();

                            Mixpanel.send('ConnectWeb Crypto Account Create Success', {
                                Resource: 'CREATE coinbase-accounts',
                            });

                        }).catch((error) => {

                            Alert.error('<strong>ETH account cannot be created.</strong>');

                            Mixpanel.send('ConnectWeb Crypto Error', {
                                Resource: 'CREATE coinbase-accounts',
                                'Error Details': error.data.errors,
                            });

                        });

                        Mixpanel.send('ConnectWeb Crypto Error', {
                            'Error Code': 'None',
                            'Error Name': 'No ETH account found',
                            Resource: 'GET coinbase-accounts',
                        });

                    }

                }).catch(() => {

                    $scope.coinbaseAccounts = [];

                });

            } else {

                $scope.dataIsLoading = false;

                Mixpanel.send('ConnectWeb Modal Open', {
                    Modal: 'Crypto Withdraw Options',
                });

            }

        };

        $scope.getAddresses = () => {

            const coinbaseCookie = $scope.getCookie('coinbase_token')
                .replace(/\\"/g, '"')
                .replace(/"{/g, '{')
                // eslint-disable-next-line no-useless-escape
                .replace(/}\"/g, '}')
                .replace(/\\054/g, ',');

            const parsedCookie = JSON.parse(coinbaseCookie);
            const coinbaseAccessToken = parsedCookie.access_token;

            if ($scope.coinbaseAccounts[0]) {

                $http({
                    method: 'GET',
                    url: `https://api.coinbase.com/v2/accounts/${$scope.coinbaseAccounts[0].id}/addresses`,
                    headers: {
                        Authorization: `Bearer ${coinbaseAccessToken}`,
                    },
                }).then((rsp) => {

                    if (rsp.data.data.length === 0) {

                        const payload = {
                            name: 'ETH Wallet',
                        };

                        $http({
                            method: 'POST',
                            url: `https://api.coinbase.com/v2/accounts/${$scope.coinbaseAccounts[0].id}/addresses`,
                            headers: {
                                Authorization: `Bearer ${coinbaseAccessToken}`,
                            },
                            payload,
                        }).then(() => {

                            $http({
                                method: 'GET',
                                url: `https://api.coinbase.com/v2/accounts/${$scope.coinbaseAccounts[0].id}/addresses`,
                                headers: {
                                    Authorization: `Bearer ${coinbaseAccessToken}`,
                                },
                            }).then((rsp2) => {

                                $scope.ethWalletAddress = rsp2.data.data[0].address;

                            });

                        });

                    } else {

                        $scope.ethWalletAddress = rsp.data.data[0].address;

                    }

                    if (rsp.data.data.length === 0) {

                        Mixpanel.send('ConnectWeb Crypto Error', {
                            'Error Code': 'None',
                            'Error Name': 'No ETH address found',
                            Resource: 'GET coinbase-addresses',
                        });

                    }

                });

            }

        };

        $scope.checkCoibaseAuth();

        $scope.withdraw = () => {

            if (!$scope.transactionConsent) {

                $scope.transactionConsentError = true;
                return;

            }

            $scope.withdrawStep = 'loading';

            Mixpanel.send('ConnectWeb Modal Button Click', {
                Modal: 'Crypto Withdraw Review',
                'Button Label': 'Confirm Withdraw',
                Destination: 'Coinbase',
                Coin: 'ETH',
                Amount: $scope.amountValue,
                'Network Fee': $scope.quote.networkFeeNumber,
            });

            const data = {
                nortonGuid: $rootScope.nortonGuid,
                currency: 'ETH',
                address: $scope.ethWalletAddress,
                amount: $scope.amountValue,
            };

            const { cryptoRestApi } = CWCONFIG;

            $http({
                method: 'POST',
                url: `${cryptoRestApi}/wallet/api/withdraw`,
                headers: {
                    Authorization: `Bearer ${Util.getToken()}`,
                },
                data,

            }).then(() => {

                Mixpanel.send('ConnectWeb Modal Open', {
                    Modal: 'Crypto Withdraw Success',
                    Destination: 'Coinbase',
                    Coin: 'ETH',
                    Amount: $scope.amountValue,
                    'Network Fee': $scope.quote.networkFeeNumber,
                });

                $scope.withdrawStep = 'withdraw-complete';

            }).catch((error) => {

                Alert.error(`<strong>${error.status}</strong>: ${error.data}`);
                Mixpanel.send('ConnectWeb Crypto Error', {
                    'Error Code': error.status,
                    'Error Name': error.data ? error.data : 'No error message',
                    Resource: 'POST withdraw',
                });
                Util.closeModal();

            });

        };

        $scope.closeModal = () => {

            Util.closeModal();

        };

        window.addEventListener('message', (event) => {

            if (event.data === 'coinbase_login') {

                $scope.checkCoibaseAuth();

            }

        });

    }

}

_serviceDependencies.push(CoinbaseAccount);

angular.module('controllers')
    .controller('CoinbaseAccount', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/coinbase-account/coinbase-account.js